<template>
  <div id="certificate-waiting">
    <div id="waiting-body">
      <img :src="successImage" alt="certificate-success">
      <h3 class="font-title-4" id="waiting-title">Selamat, Anda berhasil menyelesaikan program!</h3>
      <p class="font-body-3" id="waiting-text">Sertifikatmu sedang diproses. Mohon tunggu beberapa saat dan klik tombol di bawah ini secara berkala setiap satu menit.</p>
      <s-button
        variant="primary"
        style="width: 100%"
        @onClick="reloadPage()"
      >Lihat Sertifikat</s-button>
    </div>
  </div>
</template>

<script>
import ImageSertifikat from '@/assets/images/sertifikat/index'
import SButton from '@/components/atoms/buttons/SButton.vue'

export default {
  components: {
    SButton
  },
  data () {
    return {
      successImage: ImageSertifikat.success
    }
  },
  methods: {
    reloadPage () {
      location.reload()
    }
  }
}
</script>

<style scoped>
#certificate-waiting {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

#waiting-body {
  max-width: 400px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
}

#waiting-body > img {
  width: 184px;
  height: 158px;
  margin-bottom: 14px;
}

#waiting-title {
  color: var(--color-ui-text-main-title);
  margin-bottom: 12px;
}

#waiting-text {
  color: var(--color-ui-text-primary);
  margin-bottom: 16px;
}
</style>
